import { Link } from "react-router-dom";
import { Lock } from "lucide-react";

export function PlusGate({ title, body, testid = "plus-gate" }) {
  return (
    <div data-testid={testid} className="card p-6 bg-gradient-to-br from-[#F6EEF1] to-white">
      <div className="flex items-center gap-2 text-[#5A3E4E] mb-2">
        <Lock className="h-4 w-4" />
        <span className="eyebrow !text-[#5A3E4E]">CAMRYN Plus</span>
      </div>
      <h3 className="font-display text-xl text-stone-900 mb-1.5">{title}</h3>
      <p className="text-sm text-stone-600 leading-relaxed mb-4">{body}</p>
      <Link to="/pricing" data-testid={`${testid}-upgrade-btn`} className="btn-ink inline-flex px-5 py-2.5 rounded-full text-sm font-semibold">
        See Plus plans
      </Link>
    </div>
  );
}

export const PageTitle = ({ eyebrow, title, sub }) => (
  <div className="mb-7 rise">
    {eyebrow && <div className="eyebrow mb-2">{eyebrow}</div>}
    <h1 className="font-display text-3xl sm:text-4xl tracking-tight text-stone-900 leading-tight">{title}</h1>
    {sub && <p className="text-stone-600 mt-2 text-sm sm:text-base leading-relaxed">{sub}</p>}
  </div>
);

// Keys are character offsets: stable while streamed text grows at the end.
const withOffsets = (parts, sepLen) => {
  let at = 0;
  return parts.map((p) => { const o = { p, key: at }; at += p.length + sepLen; return o; });
};

const fmt = (s) => withOffsets(s.split(/(\*\*[^*]+\*\*)/g), 0).map(({ p, key }) =>
  p.startsWith("**") && p.endsWith("**") ? <strong key={key} className="font-semibold text-stone-900">{p.slice(2, -2)}</strong> : <span key={key}>{p}</span>);

function RichLine({ l }) {
  if (!l.trim()) return <div className="h-1" />;
  const b = l.match(/^\s*[-*•]\s+(.*)/);
  if (b) return <div className="flex gap-2"><span className="text-[#C86D51] mt-0.5">•</span><span>{fmt(b[1])}</span></div>;
  const h = l.match(/^#+\s+(.*)/);
  if (h) return <div className="font-semibold text-stone-900">{fmt(h[1])}</div>;
  return <p>{fmt(l)}</p>;
}

export function RichText({ text }) {
  return (
    <div className="space-y-1.5">
      {withOffsets((text || "").split("\n"), 1).map(({ p, key }) => <RichLine key={key} l={p} />)}
    </div>
  );
}
